import { call, put, takeEvery } from 'redux-saga/effects';
import { change } from 'redux-form';
import { postCode } from '../helpers/formHelper';
import postCodeApi from '../api/postCodeApi';
import { callApi } from './loadingSaga';
import * as Actions from '../actions/postCodeActions';

export function* onChangePostCode(action) {
  if (action.payload.zipcode !== '' && postCode(action.payload.zipcode) === undefined) {
    const response = yield call(callApi, postCodeApi.getAddress, action.payload.zipcode);
    if (response === undefined) {
      return;
    }
    yield put(change(action.payload.formName, `${action.payload.name}[prefecture]`, response.data[0].ja.prefecture));
    yield put(change(action.payload.formName, `${action.payload.name}[address1]`, response.data[0].ja.address1));
    yield put(change(action.payload.formName, `${action.payload.name}[address2]`, response.data[0].ja.address2));
  }
}

export default function* saga() {
  yield takeEvery(Actions.SAGA_GET_POST_CODE, onChangePostCode);
}
